import { render, staticRenderFns } from "./CookingCommentHistory.vue?vue&type=template&id=1e3df3ce&"
import script from "./CookingCommentHistory.vue?vue&type=script&lang=js&"
export * from "./CookingCommentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports